import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';

const PageHeading = (props) => {
  //const { title } = props;
  //return <Typography variant='h5'>{title}</Typography>;

  const navigate = useNavigate();
  return <Typography variant='h5' onClick={() => navigate(-1)}>Back</Typography>;
};

export default PageHeading;
